import React from "react";
import Block from "../Block";
import { classes } from "../utils/classes";
import { sxClassName, sxProps, textAlignPropTypes } from "../props/sx";
import { utilityClassName, utilityProps } from "../props/utility";
import { spacingClassName, spacingProps } from "../props/spacing";
import pureProps, { deepMergeProps } from "../utils/pureProps";

const CardPriceDescription = ({
	align = "center",
	className = "",
	utility = { ...utilityProps },
	sx = { ...sxProps },
	spacing = { ...spacingProps },
	children,
	...props
}) => (
	<Block
		className={classes(
			"card-price__description",
			...utilityClassName(utility),
			...sxClassName(deepMergeProps({ textAlign: align }, pureProps(sx))),
			...spacingClassName(spacing),
			className,
		)}
		{...props}
	>
		{children}
	</Block>
);

CardPriceDescription.propTypes = {
	align: textAlignPropTypes,
	...Block.propTypes,
};

export default CardPriceDescription;
